import * as React from "react";
import { useState, useEffect } from "react";
import { Suspense } from "react";
import PageContainer from "../core/PageContainer";
import Breadcrumbs from "../core/Breadcrumbs";
import jfetch from "../../utils/jfetch";
import BlogPost from "../home/BlogPost";
import ModernCard from "../core/ModernCard";
import Button from "../core/Button"
import Event from "../home/Event";
import Loader from "../core/Loader";
import { wrapComponentForErrors } from "../utility/ErrorHandler";
import Banner, { BannerDef } from "../home/Banner";
import Panel from "../core/Panel";
import {
  normalizeUserContextData,
  RailsUserContext,
} from "../../libs/user_context";
import BetaPopup from "../home/BetaPopup";
import * as Sentry from "@sentry/browser";

import bdrAd from "images/banners/BDR.jpg";
import sophosAd from "images/banners/core_refurb_madness.png";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Modal from "../core/Modal";
import VirtualEvents from "../home/VirtualEvents";
import Poll from "../home/Poll";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.....
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
  },
};

const BANNER_ADS: BannerDef[] = [
  {
    src: 'https://chartec-core-public.s3.us-west-1.amazonaws.com/banner_blackpoint.png',
    link: "https://www.blackpointcyber.com",
  },
  {
    src: 'https://chartec-core-public.s3.us-west-1.amazonaws.com/banner_bsn.png',
    link: "https://www.breachsecurenow.com",
  },
  {
    src: 'https://chartec-core-public.s3.us-west-1.amazonaws.com/banner_corkat.png',
    link: "https://www.corkatcloud.com",
  },
  {
    src: 'https://chartec-core-public.s3.us-west-1.amazonaws.com/banner_helpdesk.png',
    link: "https://www.helpdesk.tech",
  },
  {
    src: 'https://chartec-core-public.s3.us-west-1.amazonaws.com/banner_threatlocker.png',
    link: "https://threatlocker.com",
  },
];

const CrystalBallNotifications = React.lazy(() =>
  import("../crystal_ball/CrystalBallNotifications")
);

interface IProps {
  userContext: IUserContextData;
  v2_token: string;
  zoomEvents: any;
  zoomLink: string;
  hasPoll: boolean;
  poll:any;
  choices:any;
}

interface IState {
  blogPosts: ICTBlogPost[];
  loadingEvents: boolean;
  events: ICTEvent[];
  serviceNotices: IServiceNotice[];
  userContext?: IUserContextNormalized;
  alertsCount: number | null;
  featured?: any;
  featuredHtml?: any;
  showFeatModal?:boolean;
  featuredModalContent?:any;
  liveHtml?:any;
  featured_webinar?: any;
  featured_webinar_html?: any;
  zoomLive : string;
  curEvent: string;
  zoomOpen: boolean;
  scheduleLive: string;
  hasPoll: boolean;
}

class Home extends React.Component<IProps, IState> {
  state: IState = {
    blogPosts: [],
    events: [],
    serviceNotices: [],
    loadingEvents: true,
    alertsCount: null,
    userContext: normalizeUserContextData(this.props.userContext),
    featured:[],
    featuredHtml:[],
    featured_webinar:[],
    featured_webinar_html:[],
    showFeatModal: false,
    featuredModalContent : {}, 
    liveHtml : [],
    zoomLive: '',
    curEvent: '',
    zoomOpen: false, 
    scheduleLive :'',
    hasPoll:this.props.hasPoll
  };

  componentDidMount() {
    this.getBlogPosts();
    this.getEvents();
    this.getServiceNotices();
    this.getFeatured();
    // {/* removed so we dont have 2 slideshows and doubles */}
    // this.getFeaturedWebinar();
    this.checkLive();
    // add this back to check API server 
    // gets zoom settings to show zoom button
    // this.getAPI();get
    // this.setCheck();
  }

  async checkLive() {
    const res = await jfetch.get('/streams.json');
    let returnHtml = [];
    if(res){
      Object.entries(res.stream).forEach(entry => {
        let key = entry[0];
        let value : any = entry[1];
        if(value.is_live){
          returnHtml.push(
            <a key={key} href={`/live/${value.id}`} className="blink_me btn btn-live" style={{marginTop:"20px", fontSize : "20px"}}><div className="play"></div><strong>{value.title}</strong></a>
          );
        }
      })
      this.setState({ liveHtml : returnHtml});
    }
  }

  async getBlogPosts() {
    const res = await jfetch.get<{ posts: ICTBlogPost[] }>(
      `/api/core/ct_blog_posts`
    );
    if (res) this.setState({ blogPosts: res.posts });
  }

  async getEvents() {
    const res = await jfetch.get<{ events: ICTEvent[] }>(`api/core/ct_events`);
    if (res) {
      this.setState({ events: res.events, loadingEvents: false });
    }
  }

  async getServiceNotices() {
    const res = await jfetch.get<{ notices: IServiceNotice[] }>(
      `api/core/service_notices`
    );
    if (res) this.setState({ serviceNotices: res.notices });
  }

  async getFeatured() {
    const res = await jfetch.get('/library/courses/featured');
    let returnHtml = [];
    if (res){
      this.setState({ featured: res.courses });
      Object.entries(res.courses).forEach(entry => {
        let key = entry[0];
        let value : any = entry[1];

        returnHtml.push(<div key={key} className="course-card" style={{paddingLeft: "10px", paddingRight: "10px"}}>
        <div className="card single">
          <div style={{background:'rgb(171 168 168 / 27%)'}}>
            <header className="library-header" style={{backgroundImage: "url("+value.banner+")", paddingTop: '96px', backgroundSize:'contain', backgroundRepeat:'no-repeat'}}>
              <div className="btn-group pull-right library" role="group">
              </div>
            </header>
          </div>
          <div className="flippable" style={{height : "180px"}}>
            <div className="card-body front embossed-small"  style={{padding: "16px", height:'calc(100% + 0px)'}}>
              <div className="course">
                <h4 className="line-clamp-2"> {value.title}</h4>
                <p className="line-clamp-2">{value.desc}</p>
                <div className={`category pull-right ${value.color}`}>{value.category}</div>
                <div className={`action btn-theme-primary-alt pull-left ${value.color}-bg`} onClick={()=>{this.setState({featuredModalContent : value});this.setState({showFeatModal :true})}}> Preview</div>
              </div>
            </div>
          </div>
        </div>
      </div>);
      });
      this.setState({ featuredHtml : returnHtml});
    } 
  }
  // {/* removed so we dont have 2 slideshows and doubles */}
  // async getFeaturedWebinar() {
  //   const res = await jfetch.get('/library/courses/featured_webinar');
  //   let returnHtml = [];
  //   if (res){
  //     this.setState({ featured_webinar: res.courses });
  //     Object.entries(res.courses).forEach(entry => {
  //       let key = entry[0];
  //       let value : any = entry[1];

  //       returnHtml.push(<div key={key} className="course-card" style={{paddingLeft: "10px", paddingRight: "10px"}}>
  //       <div className="card single">
  //         <div style={{background:'rgb(171 168 168 / 27%)'}}>
  //           <header className="library-header" style={{backgroundImage: "url("+value.banner+")", paddingTop: '96px', backgroundSize:'contain', backgroundRepeat:'no-repeat'}}>
  //             <div className="btn-group pull-right library" role="group">
  //             </div>
  //           </header>
  //         </div>
  //         <div className="flippable" style={{height : "180px"}}>
  //           <div className="card-body front embossed-small"  style={{padding: "16px"}}>
  //             <div className="course">
  //               <h4 className="line-clamp-2"> {value.title}</h4>
  //               <p className="line-clamp-2">{value.desc}</p>
  //               <div className={`category pull-right ${value.color}`}>{value.category}</div>
  //               <a className={`action btn-theme-primary-alt pull-left ${value.color}-bg`} href={value.course_url}> Watch</a>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>);
  //     });
  //     this.setState({ featured_webinar_html : returnHtml});
  //   } 
  // }

  setCheck = () => {
    const interval = setInterval(() => {
      this.getAPI()
    }, 10*1000);
    return () => clearInterval(interval);
  }

  async getAPI(){
    let resp = await fetch(`https://api.chartec.net/v2/core/global_settings/zoom_button_settings`, {
      method: 'GET', 
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': this.props.v2_token
      }
    })
    let json = await resp.json();
    let settings = JSON.parse(json[0].json)
    this.setState({ zoomLive : settings.zoom_live, curEvent:settings.current_event, scheduleLive:settings.schedule_live});
  }

  usingSafariOrFirefox() {
    // Get the user-agent string
    let userAgentString = navigator.userAgent;
  
    // Detect Chrome
    let chromeAgent = 
        userAgentString.indexOf("Chrome") > -1;
  
    // Detect Internet Explorer
    let IExplorerAgent = 
        userAgentString.indexOf("MSIE") > -1 || 
        userAgentString.indexOf("rv:") > -1;
  
    // Detect Firefox
    let firefoxAgent = 
        userAgentString.indexOf("Firefox") > -1;
  
    // Detect Safari
    let safariAgent = 
        userAgentString.indexOf("Safari") > -1;
          
    // Discard Safari since it also matches Chrome
    if ((chromeAgent) && (safariAgent)) 
        safariAgent = false;
  
    // Detect Opera
    let operaAgent = 
        userAgentString.indexOf("OP") > -1;
          
    // Discard Chrome since it also matches Opera     
    if ((chromeAgent) && (operaAgent)) 
        chromeAgent = false;
  
    return (safariAgent || firefoxAgent)
  }

  setAlertsCount = (alertsCount: number) => {
    this.setState({ alertsCount });
  };

  render() {
    const {
      blogPosts,
      events,
      serviceNotices,
      userContext,
      loadingEvents,
      alertsCount,
    } = this.state;

    let eventsContent;
    if (loadingEvents) {
      eventsContent = <Loader />;
    } else if (events.length < 1) {
      eventsContent = "No events found right now.";
    } else {
      eventsContent = events.map(e => <Event event={e} key={e.url} />);
    }

    return (
      <PageContainer>
        {this.state.scheduleLive == 'true' && <VirtualEvents/>}
        <div className="row" style={{paddingTop:'15px'}}>
            <div className="col-lg-12">
              {this.props.zoomEvents.map((event) => {
                if(this.state.zoomLive == 'true' && (this.state.curEvent == event.id)){
                  return (
                    <button onClick={() => this.setState({zoomOpen:true})} className="btn btn-info btn-lg" key={event.id} style={{marginRight:'10px'}}>
                      {event.title} - Live Now!
                      <div className="blobs-container">
                        <div className="blob red"></div>
                      </div>
                    </button>
                  )
                }
                else{
                  return (
                    <button title="Event is not live yet" className="btn btn-info btn-lg" disabled key={event.id} style={{marginRight:'10px', minHeight:'54px'}}>{event.title}</button>
                  )
                }
              })}
            </div>
          </div>
        {this.state.liveHtml}
        {serviceNotices.map(notice => (
          <div className={`alert alert-${notice.type}`} key={notice.id}>
            <p className="lead">{notice.title}</p>
            <p>{notice.text}</p>
          </div>
        ))}
        {/* Hide sponsor slideshow */}
        {/* <div className="columns">
          <div className="column">
            <Banner banners={BANNER_ADS} />
          </div>
        </div> */}
        <Suspense fallback={null}>
          {(alertsCount === null || alertsCount > 0) && (
            <Panel
              style={{
                display:
                  alertsCount === null || alertsCount === 0
                    ? "none"
                    : undefined,
              }}
              type={"warning"}
              heading={"Alerts"}
              collapsible={true}
              startCollapsed={true}
              headerItemRight={
                alertsCount ? (
                  <span className={"badge"}>{alertsCount}</span>
                ) : null
              }
              maxBodyHeight={alertsCount ? `${alertsCount * 205}px` : "600px"}
            >
              <CrystalBallNotifications
                setAlertsCount={this.setAlertsCount}
                userContext={userContext}
              />
            </Panel>
          )}
        </Suspense>
        {this.state.featuredHtml && this.state.featuredHtml.length?
          <div style={{paddingTop : "25px"}}>
            <h4><b>Featured Courses</b></h4>
            <Carousel 
              responsive={responsive} 
              infinite={true} 
              autoPlay={true} 
              autoPlaySpeed={6000}
              customTransition="all 3s ease-out"
              >
              {this.state.featuredHtml}
            </Carousel>
          </div>
        :""}
        {/* removed so we dont have 2 slideshows and doubles */}
        {/* {this.state.featured_webinar_html && this.state.featured_webinar_html.length?
          <div style={{paddingTop : "25px"}}>
            <h4><b>Featured Content</b></h4>
            <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={3000}>
              {this.state.featured_webinar_html}
            </Carousel>
          </div>
        :""} */}
        {/* <div className="columns" style={{paddingTop : "15px"}}>
          <div className="column is-6 course-card">
            <div className="card single">
              <header className="library-header" style={{backgroundImage: "url("+covidsales+")", paddingTop: '96px'}}>
                <div className="btn-group pull-right library" role="group">
                </div>
              </header>
              <div className="flippable" style={{height : "180px"}}>
                <div className="card-body front embossed-small"  style={{padding: "16px"}}>
                  <div className="course">
                    <h5 className="pull-right"></h5>
                    <h4 className="line-clamp-2"> Covid-19 Resources - Sales and Marketing</h4>
                    <p className="line-clamp-2">Stay creative and adapt to the current climate.  Everything you need to keep your sales and marketing engines going.</p>
                    <div className="category pull-right redPurple">Sales & Marketing</div>
                    <a className="action btn-theme-primary-alt pull-left redPurple-bg" href="/library?category=covid19&category_id=359&open_tab=resources"> View</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="column is-6 course-card">
            <div className="card single">
              <header className="library-header" style={{backgroundImage: "url("+covidhr+")", paddingTop: '96px'}}>
                <div className="btn-group pull-right library" role="group">
                </div>
              </header>
              <div className="flippable" style={{height : "180px"}}>
                <div className="card-body front embossed-small"  style={{padding: "16px"}}>
                  <div className="course">
                    <h5 className="pull-right"></h5>
                    <h4 className="line-clamp-2"> Covid-19 Resources - HR</h4>
                    <p className="line-clamp-2">Keep your business safe with all the most recent documentation and changes to the laws.</p>
                    <div className="category pull-right purple">HR</div>
                    <a className="action btn-theme-primary-alt pull-left purple-bg" href="/library?category=covid19&category_id=363&open_tab=resources"> View</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="columns">
          <div className="column is-6">
            <ModernCard title="Upcoming Events" ta="left" m="0px">
              <div className="events-col">{eventsContent}</div>
            </ModernCard>
          </div>
          <div className="column is-6">
            <ModernCard title="Latest Blog Posts" ta="left" m="0px">
              <div className="blog-cols">
                {blogPosts.length > 0 ? (
                  blogPosts.map(p => <BlogPost post={p} key={p.link} />)
                ) : (
                  <Loader />
                )}
              </div>
            </ModernCard>
          </div>
        </div>
        {!this.props.hasPoll &&  <BetaPopup /> }
        {this.props.hasPoll &&  <Poll poll={this.props.poll} choices={this.props.choices} /> }
        <Modal
          title={`Preview ${this.state.featuredModalContent.title || "Unknown"}`}
          open={this.state.showFeatModal}
          submittable={false}
          closeText="Close"
          disallowClickOutside={true}
          close={() => {this.setState({showFeatModal : false, featuredModalContent : ""});}}
        >
          {this.state.featuredModalContent && Object.entries(this.state.featuredModalContent).length ?
            <div>
              <video id="preview" width="100%" controls controlsList="nodownload" src={this.state.featuredModalContent.hd_url} autoPlay/>
              <hr style={{margin : "0px"}}/>
              <div className="course" style={{padding: "5px", marginBottom : "8px"}}>
                <h4 className="line-clamp-2"> {this.state.featuredModalContent.title}</h4>
                <p className="line-clamp-2">{this.state.featuredModalContent.desc}</p>
                <div className={`category pull-right ${this.state.featuredModalContent.color}`}><b><i>{this.state.featuredModalContent.category}</i></b></div>
                <a className={`action btn-theme-primary-alt pull-left ${this.state.featuredModalContent.color}-bg`} href={this.state.featuredModalContent.course_url} onClick={()=>{this.setState({showFeatModal : false, featuredModalContent:""});}}> Go To Course</a>
              </div>
            </div>
          : "Whoops, looks like something went wrong!"}
        </Modal>
        <Modal 
              title="ZOOM Session"
              open={this.state.zoomOpen}
              submittable={false}
              closeText="Close"
              disallowClickOutside={true}
              close={() => {this.setState({zoomOpen:false})}}
            >
              
                <div>
                  <div className="alert alert-warning">
                    <strong>Attention: </strong> Zoom currently is much better supported in Chrome & Edge Browsers. 
                    If you currently use Firefox or Safari browser we highly recomenned using the zoom app instead.
                  </div>
                </div>
                {this.usingSafariOrFirefox() ? (
                  <>
                  <div className="text-center">
                    <p>View live event, open: </p>
                  </div>
                  <div className="text-center">
                      <a 
                        className="btn btn-primary"
                        href='/zoom'
                      >
                        Zoom In Browser
                      </a>             
                  </div>
                  </>
                ) : (
                  <>
                  <div className="text-center">
                    <p>View live event, open: </p>
                  </div>
                  <div style={{marginBottom:'10px'}} className="text-center">
                      <a 
                        className="btn btn-primary"
                        href='/zoom'
                      >
                        Zoom In Browser
                      </a>             
                  </div>
                  <div className="text-center">
                      <a 
                        style={{minWidth:'133px'}}
                        className="btn btn-primary"
                        href={this.props.zoomLink} 
                        target="_blank" rel="noopener noreferrer"
                      >
                        Zoom In App
                      </a> 
                  </div>
                  </>
                )}
              
            </Modal>        
      </PageContainer>
    );
  }
}



export default wrapComponentForErrors(Home);



// WEBPACK FOOTER //
// ./app/javascript/components/pages/Home.tsx